import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-60039ce6"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"20px"} }, null, -1))
const _hoisted_2 = { class: "text-h5 font-weight-medium mb-3" }
const _hoisted_3 = {
  key: 0,
  align: "center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_request_status = _resolveComponent("request-status")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_BriefOverview = _resolveComponent("BriefOverview")!
  const _component_v_sheet = _resolveComponent("v-sheet")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_request_status, {
      response: _ctx.requestResponse,
      isLoading: _ctx.isLoading
    }, null, 8, ["response", "isLoading"]),
    _createVNode(_component_v_sheet, {
      class: "align-center justify-center text-center mx-auto",
      elevation: "4",
      width: "100%",
      rounded: ""
    }, {
      default: _withCtx(() => [
        _hoisted_1,
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t("welcome-back") + " ") + _toDisplayString(_ctx.dashboardData?.title + " ") + " " + _toDisplayString(_ctx.dashboardData?.firstName + " ") + " " + _toDisplayString(_ctx.dashboardData?.lastName), 1),
        _createVNode(_component_v_divider, { class: "mb-4" }),
        (!_ctx.dashboardData?.isVerified)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_component_v_alert, {
                align: "start",
                style: {"width":"95%"},
                text: _ctx.$t('verification-on-text'),
                title: _ctx.$t('verification-on'),
                type: "info",
                density: "compact"
              }, null, 8, ["text", "title"])
            ]))
          : _createCommentVNode("", true),
        (!_ctx.dashboardData?.isProfileComplete)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "mt-3 mb-3",
              align: "center",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/doctor-profile'))),
              style: {"cursor":"pointer"}
            }, [
              _createVNode(_component_v_alert, {
                align: "start",
                style: {"width":"95%"},
                text: _ctx.$t('profile-incomplete-text'),
                title: _ctx.$t('profile-incomplete'),
                type: "warning",
                density: "compact"
              }, null, 8, ["text", "title"])
            ]))
          : _createCommentVNode("", true),
        (!_ctx.isLoading)
          ? (_openBlock(), _createBlock(_component_BriefOverview, {
              key: 2,
              class: "mb-10",
              data: _ctx.dashboardData
            }, null, 8, ["data"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}